/*
 * Copyright (C) 2023 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { usePostHog } from 'posthog-js/react';

function usePostHogUserId(): string | undefined {
  const posthog = usePostHog();

  const persistenceProps = posthog.persistence?.props;
  if (!persistenceProps) return undefined;

  const { distinct_id, $user_state } = persistenceProps;
  if (!distinct_id) return undefined;

  return $user_state === 'identified' ? distinct_id : `anon_${distinct_id}`;
}

export { usePostHogUserId };
